/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/
window.addEventListener('load', function() {
	'use strict';

	// Load event function ... most custom stuff goes here. Safer for async.
	jQuery( window ).on( 'load', function() {
		var searchForm = jQuery( '#search-form' );
		var searchInput = jQuery( '#search-input' );
		searchForm.click( function( e ) {
			if( jQuery( event.target ).hasClass( 'search-form__button' ) && searchInput.val() === "" ) {
				searchInput.focus();
			//	search.toggleClass( 'search-form--active' );
				event.preventDefault();
			} else {
				searchInput.focus();
			//	searchForm.addClass( 'search-form--active' );
			}
		});

		searchInput.focusout( function( event ) {
			if( searchInput.val() === "") {
			//	searchForm.removeClass( 'search-form--active' );
			}
		});

		searchInput.keyup( function( event ) {
			if (event.keyCode == 13) {
				searchForm.submit();
				return false;
			}
		});

		// search child dom elements for a[href], and follow that on click events 2015-11-03
		jQuery( ".linkclicker" ).click( function(e) {
			e.preventDefault();
			if ( jQuery( this ).find( "a:first" ).attr( "target" ) ) {
				// new tab
				window.open( jQuery( this ).find( "a:first" ).attr( "href" ) );
			} else {
				// same tab
				window.location = jQuery( this ).find( "a:first" ).attr( "href" );
			}
		});

		// 2016-05-15, force opening external links in new tab.
		if ( ! jQuery( 'a' ).attr( 'target' ) ) {
			jQuery( 'a[href^=http]:not([href*="' + dbs.http_host + '"])' ).attr( 'target', '_blank' ).attr( 'rel', 'noopener' );
		}

		// Enable default resize to parent function
		jQuery('.dont-resize-img').resizeToParent({parent: '.resize-parent'});
	});

	// Adding superscript <sup> tags around all trademark and registered trademark symbols
	jQuery('body :not(script,sup)').contents().filter(function() {
		return this.nodeType === 3;
	}).replaceWith(function() {
		return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
	});

	// Mobile search bar click functionality
	jQuery('.main-secondary-menu__item.search-form-menu__item').on('click', function() {
		if ( jQuery( this ).hasClass( 'open' ) ) {
			jQuery( this ).removeClass( 'open' );
			jQuery( ".site-mobile-overlay" ).removeClass( "open" );
			jQuery( this ).focus();
		} else {
			jQuery( this ).addClass( 'open' );
			jQuery( this ).find( '#search-input' ).focus();
			jQuery( ".site-mobile-ov Ferlay" ).addClass( "open" );
			if ( $( "#main-menu-toggle" ).hasClass( "open" ) ) {
				$( "#main-menu-toggle" ).removeClass( "open" );
				$( ".main-menu" ).removeClass( "open" );
				$( ".main-menu > ul[role='menu']" ).removeClass( "open" );
			}
		}
	});
	jQuery( '.main-secondary-menu__item.search-form-menu__item form' ).on( 'click', function(e) {
		e.stopPropagation();
	});
	jQuery( '.main-secondary-menu__item.search-form-menu__item' ).on( 'click', function(e) {
		e.stopPropagation();
	});
	jQuery( window ).on( 'click', function() {
		if ( jQuery( '.main-secondary-menu__item.search-form-menu__item' ).hasClass( 'open' ) ) {
			jQuery( '.main-secondary-menu__item.search-form-menu__item' ).removeClass( 'open' );
			jQuery( ".site-mobile-overlay" ).removeClass( "open" );
			jQuery( '.main-secondary-menu__item.search-form-menu__item' ).focus();
		}
	});

	// Sticky Sidebar for Product Pages.
	var sidebarHeight = 0;
	jQuery( window ).on( 'load resize', function() {
		sidebarHeight = jQuery( '#single-product__sidebar' ).outerHeight();
	} );

	function getScrollTop(){
		if(typeof pageYOffset!= 'undefined'){
			//most browsers except IE before #9
			return pageYOffset;
		}else{
			var B= document.body; //IE 'quirks'
			var D= document.documentElement; //IE with doctype
			D= (D.clientHeight)? D: B;
			return D.scrollTop;
		}
	}
	if (jQuery( '#single-product__sidebar' ).length ){

		// Code injects name of product into the ctas on single produce pages
		var productNames = document.getElementsByClassName("insert-product-name");
		var productNamesOriginal = document.getElementsByClassName("single-product_head");
		productNamesOriginal = productNamesOriginal[0].innerHTML;
		var productNamesCount;
		for (productNamesCount = 0; productNamesCount < productNames.length; productNamesCount++) {
			productNames[productNamesCount].innerHTML = productNamesOriginal;
		}

		jQuery( window ).scroll( function() {
			var grades_content = jQuery( '.single-product__grades' ).offset().top;
			var hr = jQuery( '#single-product_hr-top' ).offset().top;
			var scrollTop = jQuery( window ).scrollTop();
			var scrollTop = getScrollTop();
			var sidebar = jQuery( '#single-product__sidebar' );

			var sidebarOffset = sidebar.offset().top;
			var windowHeight = $(window).height();
				if ( sidebar.length > 0 && jQuery( window ).width() > 767 && jQuery( window ).width() < 1068 && sidebarHeight < windowHeight) {
					// THIS FUNCTIONALITY IS INTENTED ONLY TO FIRE AT THE SPECIFIC SCREEN-SIZE RANGE FOUND IN THE "IF" STATEMENT
					if ( grades_content - scrollTop <= (sidebarHeight + 60) ) {
						// THIS STOPS THE SIDEBAR FROM BEING FIXED AT THE BOTTOM OF THE PAGE
						sidebar.removeClass( 'fix-sidebar' );
						sidebar.addClass( 'sidebar-bottom' );
						/* THROUGHOUT THIS FUNCTION, I AM WRITING AND OVERRIDING CSS
						TO BETTER CONTROL WHAT CSS IS APPLIED WHEN. I WILL LABEL THEM CSS OVERRIDES. */
						sidebar.css('top', 'initial');
					} else {
						// THIS IS THE INITIAL 'FIXING' OF THE SIDEBAR
						if ( sidebarOffset > hr && hr < scrollTop ) {
							sidebar.addClass( 'fix-sidebar' );
							// CSS OVERRIDES
							sidebar.css('top', 20);
						} else {
							sidebar.removeClass( 'fix-sidebar' );
						}
						sidebar.removeClass( 'sidebar-bottom' );
					}
				} else if (sidebar.length > 0 && jQuery( window ).width() >= 1068 && sidebarHeight < windowHeight) {
					// THIS FUNCTIONALITY IS INTENTED TO FIRE AT OR ABOVE THE SCREEN WIDTH FOUND IN THE "IF" STATEMENT
					var footer = jQuery( 'body' ).outerHeight() - jQuery( '.site-footer' ).outerHeight();
					if ( footer - scrollTop - sidebarHeight <= 200 ) {
						var differenceFromBottom = $('.single-product__data').outerHeight() - sidebarHeight - 180;
						sidebar.css('top', differenceFromBottom);
						sidebar.removeClass( 'fix-sidebar' );
						sidebar.addClass( 'sidebar-bottom' );
					} else {
						// THIS IS THE INITIAL 'FIXING' OF THE SIDEBAR
						if ( footer - scrollTop - sidebarHeight > 200 && sidebarOffset > hr && hr < scrollTop) {
							sidebar.addClass( 'fix-sidebar' );
							// CSS OVERRIDES
							sidebar.css('top', 20);

						} else {
							sidebar.removeClass( 'fix-sidebar' );
						}
						sidebar.removeClass( 'sidebar-bottom' );
					}
				} else {
					sidebar.removeClass( 'sidebar-bottom' );
					sidebar.removeClass( 'fix-sidebar' );
				}


					// ADDS THE CONDITION THAT THE ENTIRE SIDEBAR MUST BE VISIBLE TO ENABLE THE STICKY SIDEBAR

			// Highlights relevant sidebar item when element is scrolled into view
			$('.attribute_title, .applications_title').each(function() {
				var half_height = $(window).height()/2;
				if($(window).scrollTop() >= $(this).offset().top - half_height) {
					var id = $(this).attr('id');
					if ($('.single-product__sidebar a[href="#'+id+'"]')){
						$('.single-product__sidebar a.in-view-color:not([href="#'+id+'"]').removeClass('in-view-color');
						$('.single-product__sidebar a[href="#'+id+'"]').addClass('in-view-color');
					}
				}
			});
		} );

		// Scroll slower when back to top button clicked on single product pages
		$( '.back_to_top' ).on( 'click', function() {
			$('html, body').animate({ scrollTop: "0px" }, 500);
		});


		/**
		 * Shows the cta when appropriate
		 */
		(function() {
			var floating_cta = jQuery( '#floating-cta' );

			if (floating_cta.length === 0) {
				return; /// There is no floating cta on this page.
			}

			// Flag to see if the cta is visible, this helps to prevent excessive cpu processing
			var floating_cta_is_visible = false;


			// Keep track of the visible range (top and bottom)
			var visible_top = 0;
			if ( jQuery( '.single-product__data' ).length !== 0 ) {
				visible_top = jQuery( '.single-product__data' ).first().offset().top;
			}

			var visible_bottom = window.scrollY - window.innerHeight;
			if ( jQuery( '.bottom-of-page--cta' ).length !== 0 ) {
				visible_bottom = jQuery( '.bottom-of-page--cta' ).first().offset().top - window.innerHeight;
			}

			// On debounceScroll, see if we need to show or hide the cta
			window.addEventListener( 'debounceScroll', function() {
				var scroll_top = jQuery( window ).scrollTop();

				if ( floating_cta_is_visible && (
					( visible_top > scroll_top ) || ( scroll_top > visible_bottom ) ) ) {
					floating_cta.removeClass( 'show' );
					floating_cta_is_visible = false;

				} else if (! floating_cta_is_visible && (
					( visible_top < scroll_top ) && ( scroll_top < visible_bottom ) ) ) {
					floating_cta.addClass( 'show' );
					floating_cta_is_visible = true;
				}
			});

			// Every time the window is loaded or resized, update the top and bottom ranges
			jQuery( window ).on( 'load resize', function() {
				// Added conditionals to ensure that the elements exist before checking their offset to prevent errors - JG 1/28/19
				if (jQuery( '.single-product__data' ).length) {
					visible_top = jQuery( '.single-product__data' ).first().offset().top;
				}

				if (jQuery( '.bottom-of-page--cta' ).length) {
					visible_bottom = jQuery( '.bottom-of-page--cta' ).first().offset().top - window.innerHeight;
				}				
			});
		})()
		//////////////////////////////////////////////////////////////////////////


		// Lightbox for product pages
		$('.single-product__content img').not('a img').on('click', function(e) {
			// This function controls the opening of the lightbox
			e.preventDefault();
			$('.box').animate({'opacity': '1.0'}, 500);
			$(".backDrop").animate({"opacity": ".70"}, 500);
			$(".backDrop, .close-lightbox, .box").css("display", "block");
			var largeImage = $(this).attr("src");
			$(".largeImage").attr({src: largeImage});
		});

		function closeBox(){
			// This function controls the closing of the lightbox
			$(".backDrop, .box").animate({"opacity": "0"}, 500);
			$(".backDrop, .close-lightbox, .box").css("display", "none");
		};
		// Closes the lightbox on click
		$(".close-lightbox, .backDrop").on("click", function(){
			closeBox();
		});
	}

	// ADDS CLASS THAT CONTROLS THE COLLAPSE/EXPAND FUNCTIONALITY OF THE GRADE TABLES.
	$('.grades_title').each(function() {
		$(this).on('click', function() {
			$(this).toggleClass('expand');
		})
	});

	// ADDS CLASS THAT CONTROLS THE COLLAPSE/EXPAND FUNCTIONALITY OF THE NEWS PAGE.
	$('.press-releases__collapsable h3').each(function() {
		$(this).on('click', function() {
			$(this).toggleClass('content-expanded');

			if ($(this).hasClass('content-expanded')) {
				$('.content-expanded').next().addClass('expand');
			} else {
				$(this).next('.press-releases__content').removeClass('expand');
			}
		})
	});


	// THE INTIAL STATE OF THIS VARIABLE IS AN OPACTICY OF 0. ON SCROLL, THE OPACITCY WILL BE ALTERED
	var pageTop = $('html').offset().top;
	var windowScrollTop = jQuery( window ).scrollTop() + jQuery( window ).outerHeight();

	var siteHeight = jQuery( '.site' ).outerHeight();
	var siteFooterHeight = jQuery( '.site-footer' ).outerHeight();
	var backToTopLink = jQuery( '.back_to_top' );
	backToTopLink.addClass( 'back_to_top--still' );

	jQuery( window ).on( 'load resize', function() {
		if ( jQuery( document ).width() >= 768 ) {
			siteHeight = jQuery( document ).outerHeight();
			siteFooterHeight = jQuery( '.site-footer' ).outerHeight();
			jQuery( window ).scroll( function() {
				// windowScrollTop = jQuery( window ).scrollTop() + jQuery( window ).outerHeight();
				if( windowScrollTop > 300 ){
					backToTopLink.removeClass( 'back_to_top--still' );
				}

				if ( ( windowScrollTop - 128 ) >= ( siteHeight - siteFooterHeight ) ) {
					backToTopLink.css( { 'position': 'absolute', 'right': '0', 'bottom': '0', 'transition': 'unset'} );
				} else if ( ( windowScrollTop - 128 ) <= ( siteHeight - siteFooterHeight ) ) {
					backToTopLink.css( { 'position': 'fixed', 'right': '0', 'bottom': '173px' } );
				}
			});
		} else {
			// backToTopLink.removeClass( 'back_to_top--scrolling' );
			jQuery( window ).scroll( function() {
				backToTopLink.addClass( 'back_to_top--scrolling' );
				backToTopLink.removeClass( 'back_to_top--still' );
			});
			// Sticky back to top button
			backToTopLink.css( { 'position': 'fixed', 'right': '0', 'bottom': '0', 'transition': 'unset'} );
		}
	});

	// Scroll slower down when above continue button is clicked
	$( '.fp-continue-button' ).on( 'click', function() {
		$('html, body').animate({ scrollTop: $('.site-header').outerHeight() + $('.home .jumbotron-container').outerHeight() }, 500);
	});

	// Locations Map
	if( $('.layout-responsive-locations-map').length > 0){
		$('body').addClass('map-page');
	}
	// UI Darkening on Location Point Hovering
	$( '.location-info-point__positioner' ).on( 'mouseover', function() {
		$('.location-info-point__positioner').removeClass('open');
		$( this ).addClass('open');
	});
	$( '.location-info-point__positioner' ).on( 'mouseleave', function() {
		$( this ).removeClass('open');
	});
	$( '.location-info-point__positioner' ).on( 'mouseover', function() {
		$('.map-page').addClass('darken-ui');
	});
	$( '.info-point__container' ).on( 'mouseleave', function() {
		$('.map-page').removeClass('darken-ui');
	});
	$( '.location-info-point__positioner' ).on( 'mouseleave', function() {
		$('.map-page').removeClass('darken-ui');
	});

	$( '.map-page .site-content' ).on( 'mouseleave', function() {
		$('.map-page').removeClass('darken-ui');
		$( '.location-info-point__positioner' ).removeClass('open');
	});

	// Locations Map menu
	$('.info-point__menu-item:first-of-type').on('mouseover', function(e) {
	    $('.location-info-point__positioner:first-of-type').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(2)').on('mouseover', function(e) {
	    $('.location-info-point__positioner:nth-child(2)').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(3)').on('mouseover', function(e) {
	    $('.location-info-point__positioner:nth-child(3)').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(4)').on('mouseover', function(e) {
	    $('.location-info-point__positioner:nth-child(4)').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(5)').on('mouseover', function(e) {
	    $('.location-info-point__positioner:nth-child(5)').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(6)').on('mouseover', function(e) {
	    $('.location-info-point__positioner:nth-child(6)').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(7)').on('mouseover', function(e) {
	    $('.location-info-point__positioner:nth-child(7)').trigger(e.type);
	});
	$('.info-point__menu-item:last-of-type').on('mouseover', function(e) {
	    $('.location-info-point__positioner:last-of-type').trigger(e.type);
	});


	$('table.nipol a:not([href*=""])').each(function() {
		var builtURL = '/wp-content/uploads/nipol-'+ $(this).text() +'.pdf';
		$(this).attr('href', builtURL );
	});
	$('table.hydrin a:not([href*=""])').each(function() {
		var builtURL = '/wp-content/uploads/hydrin-'+ $(this).text() +'.pdf';
		$(this).attr('href', builtURL );
	});
	$('table.chemisat a:not([href*=""])').each(function() {
		var builtURL = '/wp-content/uploads/chemisat-'+ $(this).text() +'.pdf';
		$(this).attr('href', builtURL );
	});
	$('table.hytemp a:not([href*=""])').each(function() {
		var builtURL = '/wp-content/uploads/hytemp-'+ $(this).text() +'.pdf';
		$(this).attr('href', builtURL );
	});
	$('table.zeoforte a:not([href*=""])').each(function() {
		var builtURL = '/wp-content/uploads/zeoforte-'+ $(this).text() +'.pdf';
		$(this).attr('href', builtURL );
	});

	//COULD BE BETTER
	var gradeLinks = [
		'chemisat-lch-7302x.pdf',
		'hydrin-c2000.pdf',
		'hydrin-c2000.pdf',
		'hydrin-c2000l.pdf',
		'hydrin-c2000l.pdf',
		'hydrin-c2000ll.pdf',
		'hydrin-c2000ll.pdf',
		'hydrin-c2000m.pdf',
		'hydrin-c2000m.pdf',
		'hydrin-c2000xl.pdf',
		'hydrin-c2000xl.pdf',
		'hydrin-h1100.pdf',
		'hydrin-h1100.pdf',
		'hydrin-h45.pdf',
		'hydrin-h45.pdf',
		'hydrin-h55.pdf',
		'hydrin-h55.pdf',
		'hydrin-h65.pdf',
		'hydrin-h65.pdf',
		'hydrin-px.pdf',
		'hydrin-t3000.pdf',
		'hydrin-t3000.pdf',
		'hydrin-t3000l.pdf',
		'hydrin-t3000l.pdf',
		'hydrin-t3000ll.pdf',
		'hydrin-t3000ll.pdf',
		'hydrin-t3100.pdf',
		'hydrin-t3100.pdf',
		'hydrin-t3102.pdf',
		'hydrin-t3102.pdf',
		'hydrin-t3105.pdf',
		'hydrin-t3105.pdf',
		'hydrin-t3105b.pdf',
		'hydrin-t3105b.pdf',
		'hydrin-t3106.pdf',
		'hydrin-t3106.pdf',
		'hydrin-t3108.pdf',
		'hydrin-t3108.pdf',
		'hydrin-t3108xl.pdf',
		'hydrin-t3108xl.pdf',
		'hydrin-t5010.pdf',
		'hydrin-t5010.pdf',
		'hytemp-4051cg.pdf',
		'hytemp-4051ep.pdf',
		'hytemp-4052ep.pdf',
		'hytemp-4053ep.pdf',
		'hytemp-4054.pdf',
		'hytemp-4065.pdf',
		'hytemp-4451cg.pdf',
		'hytemp-4454.pdf',
		'hytemp-ar12.pdf',
		'hytemp-ar12b.pdf',
		'hytemp-ar14.pdf',
		'hytemp-ar212hr.pdf',
		'hytemp-ar212xp.pdf',
		'hytemp-ar214.pdf',
		'hytemp-ar22.pdf',
		'hytemp-ar71.pdf',
		'hytemp-ar715.pdf',
		'hytemp-ar71l.pdf',
		'hytemp-ar72lf.pdf',
		'hytemp-ar74.pdf',
		'hytemp-h570.pdf',
		'hytemp-hr200.pdf',
		'hytemp-npc50.pdf',
		'hytemp-ns70.pdf',
		'hytemp-pv04.pdf',
		'hytemp-sc75.pdf',
		'hytemp-sr50.pdf',
		'nipol-1000x132.pdf',
		'nipol-1001cg.pdf',
		'nipol-1001lg.pdf',
		'nipol-1002.pdf',
		'nipol-1014.pdf',
		'nipol-1022x59.pdf',
		'nipol-1031.pdf',
		'nipol-1032-45.pdf',
		'nipol-1032j.pdf',
		'nipol-1034-60.pdf',
		'nipol-1041.pdf',
		'nipol-1041l.pdf',
		'nipol-1042.pdf',
		'nipol-1043.pdf',
		'nipol-1051.pdf',
		'nipol-1052.pdf',
		'nipol-1052j.pdf',
		'nipol-1053.pdf',
		'nipol-1072.pdf',
		'nipol-1072cgj.pdf',
		'nipol-1072cgx.pdf',
		'nipol-1072x28.pdf',
		'nipol-1082v.pdf',
		'nipol-1092-80.pdf',
		'nipol-1094-80.pdf',
		'nipol-1203w.pdf',
		'nipol-1312.pdf',
		'nipol-1312lv.pdf',
		'nipol-1401lg.pdf',
		'nipol-1411.pdf',
		'nipol-1411c.pdf',
		'nipol-1442.pdf',
		'nipol-1472x.pdf',
		'nipol-3640s.pdf',
		'nipol-4040s.pdf',
		'nipol-dn003.pdf',
		'nipol-dn1201.pdf',
		'nipol-dn1201l.pdf',
		'nipol-dn171.pdf',
		'nipol-dn202.pdf',
		'nipol-dn214.pdf',
		'nipol-dn219.pdf',
		'nipol-dn2850.pdf',
		'nipol-dn2880.pdf',
		'nipol-dn302.pdf',
		'nipol-dn302h.pdf',
		'nipol-dn3335.pdf',
		'nipol-dn3350.pdf',
		'nipol-dn3380.pdf',
		'nipol-dn3635.pdf',
		'nipol-dn3650.pdf',
		'nipol-dn401l.pdf',
		'nipol-dn401ll.pdf',
		'nipol-dn4050.pdf',
		'nipol-dn4080.pdf',
		'nipol-dn4555.pdf',
		'nipol-dn4555a.pdf',
		'nipol-dn4580.pdf',
		'nipol-dn508scr.pdf',
		'nipol-n917.pdf',
		'nipol-ns116r.pdf',
		'nipol-ns612.pdf',
		'nipol-ns616.pdf',
		'nipol-ns460.pdf',
		'nipol-ns522.pdf',
		'nipol-nx775.pdf',
		'sivic-z2710.pdf',
		'sivic-z530.pdf',
		'sivic-z620.pdf',
		'sivic-z700px.pdf',
		'sivic-z702.pdf',
		'sivic-z711.pdf',
		'sivic-z711lv.pdf',
		'sivic-z730.pdf',
		'sivic-z730m60.pdf',
		'sivic-z740.pdf',
		'sivic-z760.pdf',
		'zealloy-1422.pdf',
		'zealloy-1422x14.pdf',
		'zeoforte-zsc-2095cx.pdf',
		'zeoforte-zsc-2095cx.pdf',
		'zeoforte-zsc-2195cx.pdf',
		'zeoforte-zsc-2195cx.pdf',
		'zeoforte-zsc-2195h.pdf',
		'zeoforte-zsc-2195h.pdf',
		'zeoforte-zsc-2195lcx.pdf',
		'zeoforte-zsc-2195lcx.pdf',
		'zeoforte-zsc-2295cx.pdf',
		'zeoforte-zsc-2295cx.pdf',
		'zeoforte-zsc-2295l.pdf',
		'zeoforte-zsc-2295l.pdf',
		'zeoforte-zsc-2395.pdf',
		'zetpol-1000l.pdf',
		'zetpol-1010.pdf',
		'zetpol-1010ep.pdf',
		'zetpol-1020.pdf',
		'zetpol-2000.pdf',
		'zetpol-2000l.pdf',
		'zetpol-2001.pdf',
		'zetpol-2001ep.pdf',
		'zetpol-2010.pdf',
		'zetpol-2010ep.pdf',
		'zetpol-2010h.pdf',
		'zetpol-2010l.pdf',
		'zetpol-2020.pdf',
		'zetpol-2020ep.pdf',
		'zetpol-2030l.pdf',
		'zetpol-2230lx.pdf',
		'zetpol-2510.pdf',
		'zetpol-3310.pdf',
		'zetpol-3310ep.pdf',
		'zetpol-3610.pdf',
		'zetpol-3710.pdf',
		'zetpol-4300.pdf',
		'zetpol-4300ep.pdf',
		'zetpol-4310.pdf',
		'zetpol-4310ep.pdf'
	];
	if( $('.single-product_head').length ){

		console.log('Run product PDF filter.');
		var productTitle = $('.single-product_head').text().toLowerCase();
		var pdfStart = false;

		if( productTitle.indexOf("zetpol") !== -1 ){
			console.log('Product Zetpol');
			pdfStart = ['zetpol','zeoforte','chemisat'];
		}else if (productTitle.indexOf("nipol") !== -1) {
			console.log('Product Nipol');
			pdfStart = ['nipol','sivic','zealloy'];
		}else if (productTitle.indexOf("hytemp") !== -1) {
			console.log('Product Hytemp');
			pdfStart = ['hytemp'];
		}else if (productTitle.indexOf("hydrin") !== -1) {
			console.log('Product Hydrin');
			pdfStart = ['hydrin'];
		}else{
			console.log('No product type found.');
		}

		var pdfsLinked = 0;
		$('th.column-1').each(function() {
			if (pdfStart && $(this).text() == 'Product Grade') {
				var gradeTable = $(this).closest('table');
				gradeTable.find('td.column-1').each(function() {
					for (var i = 0, len = pdfStart.length; i < len; i++) {
						var productStr = pdfStart[i] + '-' + $(this).text() + '.pdf';
						productStr = productStr.replace(/\s+/g, '-').toLowerCase();
		
						if (gradeLinks.indexOf(productStr) >= 0) {
							$(this).wrapInner('<strong></strong>');
							pdfsLinked++;
						}
					}
				});
			}
		});
		// console.log( pdfsLinked + ' PDF Links Created.');
	}

	/**
	 * Captures Google Analytics Client ID and inputs into hidden form field
	 */
	function fillClientId() {
		// ga does not exist on local or staging.
		if ( typeof ga === "undefined" ) return; 
		// Capture Client ID
		var clientId = ga.getAll()[0].get('clientId');
		// Populate hidden form field with Client ID
		jQuery('.g-id input').val(clientId);
	}

	// On pages with client ID form field, populate
	if (jQuery('.g-id input').length) {
		// Give GTM time to load
		setTimeout(function() {
			fillClientId();
		}, 2000);
	}

});
